import { discussionsService } from '@/services'

export default {
  state: {
    discussion: null,
    discussions: [],
    draftDiscussions: [],
    messages: [],
    messageReactions: [],
    reactions: []
  },

  mutations: {
    setDiscussion (state, value) {
      state.discussion = value
    },

    setDiscussions (state, value) {
      state.discussions = value
    },

    setDraftDiscussions (state, value) {
      state.draftDiscussions = value
    },

    updateDiscussion (state, value) {
      state.discussions = state.discussions.map(item => {
        if (item.id === value.id) {
          return {
            ...item,
            ...value
          }
        }
        return item
      })
      state.draftDiscussions = state.draftDiscussions.map(item => {
        if (item.id === value.id) {
          return {
            ...item,
            updatedAt: new Date(),
            ...value
          }
        }
        return item
      })

      if (state.discussion?.id === value.id) {
        state.discussion = {
          ...state.discussion,
          ...value
        }
      }
    },

    deleteDiscussion (state, id) {
      state.discussions = state.discussions.filter(item => item.id !== id)
      state.draftDiscussions = state.draftDiscussions.filter(item => item.id !== id)
    },

    addDiscussion (state, value) {
      const discussions = state.discussions

      discussions.unshift(value)

      state.discussions = discussions
    },

    addDraftDiscussion (state, value) {
      const discussions = state.draftDiscussions

      discussions.unshift(value)

      state.draftDiscussions = discussions
    },

    postDiscussion (state, value) {
      const discussions = state.discussions
      discussions.unshift({
        ...value,
        isDraft: false
      })
      state.discussions = discussions
    },

    deleteDraftDiscussion (state, value) {
      state.draftDiscussions = state.draftDiscussions.filter(item => item.id !== value.id)
    },

    setDiscussionMessage (state, value) {
      const messages = state.messages

      messages.push(value)

      state.messages = messages
    },

    updateDiscussionMessagesCount (state, value) {
      state.discussions = state.discussions.map(item => {
        if (item.id === value.discussionId) {
          let msgs = item.discussionMessages
          if (value.state === 'add') {
            msgs.push(value)
          } else {
            msgs = msgs.filter(item => item.id !== value.id)
          }

          return {
            ...item,
            discussionMessages: msgs
          }
        }
        return item
      })
    },

    setDiscussionMessages (state, value) {
      state.messages = value.messages.reverse()
      state.messageReactions = value.reactions
    },

    updateDiscussionMessage (state, value) {
      state.messages = state.messages.map(item => {
        if (item.id === value.id) {
          return {
            ...item,
            ...value
          }
        }
        return item
      })
    },

    deleteDiscussionMessage (state, value) {
      state.messages = state.messages.filter(item => item.id !== value)
    },

    setReactions (state, value) {
      state.reactions = value
    },

    toggleReaction (state, { messageId, reactionId, userId, user, isSelected, discussionId }) {
      if (isSelected) {
        if (discussionId) {
          const index = state.discussion.reactions.findIndex(item => item.userId === userId && item.discussionId === discussionId)
          state.discussion.reactions.splice(index, 1)
        } else {
          const index = state.messageReactions.findIndex(item => item.userId === userId && item.discussionMessageId === messageId)
          state.messageReactions.splice(index, 1)
        }
      } else {
        if (discussionId) {
          const reactions = state.discussion.reactions
          reactions.push({
            discussionId: discussionId,
            id: Math.random(),
            reactionId,
            user: user,
            userId: userId
          })
          state.discussion.reactions = reactions
        } else {
          const reactions = state.messageReactions
          reactions.push({
            discussionMessageId: messageId,
            id: Math.random(),
            reactionId,
            user: user,
            userId: userId
          })
          state.messageReactions = reactions
        }
      }
    },

    toggleMember (state, { member, discussionId, bookId, isSelected }) {
      const discussion = state.discussions.find(item => item.id === discussionId)

      let members = []

      if (discussion) {
        members = discussion.teamMembers
      } else {
        members = state.discussion.teamMembers
      }

      if (isSelected) {
        members = members.filter(m => m.id !== member.id)
      } else {
        members.push({
          id: member.id,
          user: {
            profile: member
          }
        })
      }

      if (state.discussion.id === discussionId) {
        state.discussion.teamMembers = members
      }

      state.discussions = state.discussions.map(item => {
        if (item.id === discussionId) {
          return {
            ...item,
            teamMembers: members
          }
        }
        return item
      })
    },

    resolve (state, { messageId, discussionId, resolvedAt }) {
      state.messages = state.messages.map(item => {
        if (item.id === messageId) {
          return {
            ...item,
            resolvedAt: resolvedAt
          }
        }
        return item
      })

      state.discussions = state.discussions.map(item => {
        if (item.id === discussionId) {
          return {
            ...item,
            resolvedAt: resolvedAt
          }
        }
        return item
      })

      if (state.discussion?.id === discussionId) {
        state.discussion.resolvedAt = resolvedAt
      }
    }
  },

  actions: {
    async getDiscussion ({ commit }, { id, bookId }) {
      const { data } = await discussionsService.getById({ id, bookId })
      commit('setDiscussion', data.discussion)
      return data.discussion
    },

    async getDiscussions ({ commit }, { bookIds }) {
      const { data } = await discussionsService.getAll({ bookIds })
      commit('setDiscussions', data.discussions)
    },

    async getDraftDiscussions ({ commit }, { bookIds }) {
      const { data } = await discussionsService.getDraft({ bookIds })
      commit('setDraftDiscussions', data.discussions)
    },

    async createDiscussion ({ commit }, { title, content, memberIds, bookId }) {
      return discussionsService.create({ title, content, memberIds, bookId })
    },

    async postDiscussion (_, { id, bookId, memberIds }) {
      return discussionsService.post({ id, bookId, memberIds })
    },

    async updateDiscussion ({ commit }, value) {
      await discussionsService.update(value)
      commit('updateDiscussion', value)
    },

    async deleteDiscussion ({ commit }, { id, bookId }) {
      commit('toggleBookLoading', true)

      try {
        await discussionsService.delete({ id, bookId })
        commit('toggleBookLoading', false)
        commit('deleteDiscussion', id)
      } catch {
        return commit('toggleBookLoading', false)
      }
    },

    addDiscussionMessage (_, { discussionId, bookId, text }) {
      return discussionsService.addMessage({ discussionId, bookId, text })
    },

    async deleteDiscussionMessage ({ commit }, { id, bookId }) {
      await discussionsService.deleteMessage({ id, bookId })
      commit('deleteDiscussionMessage', id)
    },

    async updateDiscussionMessage ({ commit }, { id, bookId, text }) {
      await discussionsService.updateMessage({ id, bookId, text })
      commit('updateDiscussionMessage', { id, text })
      return { id }
    },

    async getDiscussionMessages ({ commit }, { discussionId, bookId, page = 0 }) {
      const { data } = await discussionsService.getMessages({ discussionId, bookId, page })
      return commit('setDiscussionMessages', data)
    },

    async getReactions ({ commit }) {
      const reactions = await discussionsService.getReactions()
      commit('setReactions', reactions.data.reactions)
    },

    async toggleReaction ({ commit }, { messageId, reactionId, userId, user, bookId, isSelected, discussionId }) {
      await discussionsService.toggleReaction({ messageId, reactionId, bookId, discussionId })
      commit('toggleReaction', { messageId, reactionId, userId, user, bookId, isSelected, discussionId })
    },

    async toggleMember ({ commit }, { member, discussionId, bookId, isSelected }) {
      await discussionsService.toggleMember({ memberId: member.id, discussionId, bookId })
      commit('toggleMember', { member, discussionId, bookId, isSelected })
    },

    async resolve ({ commit }, { messageId, discussionId, bookId, resolvedAt }) {
      await discussionsService.resolve({ id: messageId, bookId })
      commit('resolve', { messageId, discussionId, resolvedAt })
    }
  }
}
